// [목적] SW Cache Storage 중 폴리오 상세 캐시('-folio' 접미사, public/sw.js 참조)만 삭제하는 공용 헬퍼
// [이유] security/2026-09-17_m5-m11-final.md L-7 — 기존에는 useAuth.logout() 버튼 경로에서만
//        caches 정리가 이뤄져 세션 만료·강제 로그아웃(AuthProvider gangwon:logout 이벤트)·회원 탈퇴
//        경로에서는 공용 기기에 폴리오 상세(private/viewer 포함)가 남는 문제가 있었다 —
//        3개 호출부(useAuth.logout / AuthProvider handleLogout / useDeleteAccount onSuccess)가
//        동일 로직을 공유하도록 추출.
// [사이드 이팩트] '-folio' 로 끝나지 않는 캐시(예: gw-v2-shell, gw-v2-assets)는 그대로 유지.
//                Cache Storage 미지원 환경(비보안 컨텍스트 등)에서는 조용히 무시(best-effort).
// [수정 시 고려사항] 캐시명 규칙('-folio' 접미사)은 public/sw.js 와 동기화 필요 — 규칙 변경 시 이 파일도 갱신.
//                   여러 호출부에서 중복 호출돼도 caches.delete 는 멱등(존재하지 않는 키는 false 반환)이라 안전.
export async function clearUserCaches(): Promise<void> {
  try {
    const keys = await caches.keys();
    await Promise.all(keys.filter((k) => k.endsWith('-folio')).map((k) => caches.delete(k)));
  } catch {
    // Cache Storage 미지원(비보안 컨텍스트 등) — 무시
  }
}
